import useTicketStatsQuery from '~/hooks/services/servicenow/queries/useTicketStatsQuery'

import { FcOk } from 'react-icons/fc'
import { useNavigate } from 'react-router'

import { Tile, TileHeader } from '../Tile'

const ClosedTicketsTile = () => {
  const navigate = useNavigate()
  const { data: ticketStats, isLoading } = useTicketStatsQuery()

  return (
    <Tile onMouseDown={() => navigate('/tickets?state=closed')}>
      <TileHeader loading={isLoading}>
        <TileHeader.Title>{ticketStats?.closed ?? 0}</TileHeader.Title>
        <TileHeader.Subtitle>Closed</TileHeader.Subtitle>
        <TileHeader.Item>
          <FcOk className="h-10 w-10" />
        </TileHeader.Item>
      </TileHeader>
    </Tile>
  )
}

export default ClosedTicketsTile
